import { render, staticRenderFns } from "./PcpContent.vue?vue&type=template&id=36954aa6"
import script from "./PcpContent.vue?vue&type=script&lang=js"
export * from "./PcpContent.vue?vue&type=script&lang=js"
import style0 from "./PcpContent.vue?vue&type=style&index=0&id=36954aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports